export default "__VITE_ASSET__DfeIrEue__"